<template>
    <div class="settings-wrapper">
        <div class="container settings-component">
            <div class="row">
                <div class="col-xs-24 col-sm-5" v-show="!isMobile">
                    <ul class="nav nav-pills nav-stacked">
                        <li :class="{ active: tabActive === 'profile' }">
                            <router-link :to="{ name: 'profile_update' }"
                                >{{ $t('perfil') }}</router-link
                            >
                        </li>
                        <li :class="{ active: tabActive === 'friends' }">
                            <router-link :to="{ name: 'friends_setting' }"
                                >{{ $t('amigos') }}</router-link
                            >
                        </li>
                        <li v-if="identityValidationAvailable" :class="{ active: tabActive === 'identity_validation' }">
                            <router-link :to="{ name: 'identity_validation' }"
                                >{{ $t('validarIdentidad') }}</router-link
                            >
                        </li>
                        <!--
                        <li>
                            <a href="#">Dispositivos</a>
                        </li>
                        -->
                    </ul>
                </div>
                <div class="col-xs-24 col-sm-19">
                    <router-view></router-view>
                </div>
            </div>
        </div>

        <!-- Section Footer -->
        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Découvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits réservés.
                </p>
            </div>
        </footer>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: 'settings',
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            isMobile: 'device/isMobile',
            config: 'auth/appConfig'
        }),
        tabActive() {
            return this.$route.meta.tab;
        },
        identityValidationAvailable() {
            const c = this.config;
            return c && (c.identity_validation_mercado_pago_enabled === true || c.identity_validation_manual_enabled === true);
        }
    },
    methods: {},
    watch: {},

    mounted() {},
    components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* Styles non-scoped pour cacher le footer global sur les pages settings */
.app-container.profile_update .footer-component,
.app-container.friends_setting .footer-component,
.app-container.identity_validation .footer-component,
.app-container.identity_validation_manual .footer-component,
.app-container.identity_validation_sms .footer-component {
    display: none !important;
}
</style>

<style scoped>
.settings-wrapper {
    margin: 0;
    padding: 0;
    /* Flexbox pour pousser le footer en bas */
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 100%;
}

.settings-component {
    /* Prend l'espace disponible pour pousser le footer en bas */
    flex: 1;
}

@media only screen and (min-width: 768px) {
    .settings-component {
        margin: 2em;
        min-height: auto;
    }
    .container {
        margin: 0;
        padding: 2em;
        width: 100%;
        min-height: auto;
    }
}

/* Section Footer */
.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 4rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

/* Responsive Footer */
@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .footer-section {
        padding: 2rem 1rem 1rem;
        margin-top: 3rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .footer-section {
        padding: 1.5rem 1rem;
        margin-top: 2rem;
    }

    .footer-logo {
        width: 35px;
        height: 35px;
    }

    .footer-brand-name {
        font-size: 1.1rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.2rem;
    }

    .footer-column-title {
        font-size: 0.95rem;
    }

    .footer-links a {
        font-size: 0.85rem;
    }

    .social-link {
        width: 40px;
        height: 40px;
    }

    .social-link i {
        font-size: 1.1rem;
    }
}
</style>
